import * as types from "../actions/ActionTypes";
import {CategoryInitial} from "../store/InitialStore";

export default function CategoryReducer(state = CategoryInitial, action) {
  const { type, payload} = action;
  switch (type) {
   case types.ADD_CATEGORY:
       return [...state,payload]
  case types.CATEGORY_DETAILS:
      return state=payload
      case types.NEWFORM:
          return state=[]
    case types.CATEGORY_ONCHANGE:

      return state=payload
    default:
    return state;
  }
}
